module.exports = new __parcel__URL__("cancel_button.56ac77cb.png").toString();